import { render, staticRenderFns } from "./NavigationDrawerListGroupOrders.vue?vue&type=template&id=7f0b7d41"
import script from "./NavigationDrawerListGroupOrders.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawerListGroupOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports